import React from 'react';

import { trans } from '@spotahome/soyuz/client';

const Error = () => (
  <div className="error">
    {trans('error_page.client_error.content.message')}
  </div>
);

export default Error;
